import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ExtraContentComponent from './ExtraContentComponent';

export interface ExtraContentOptions {
    HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        extraContent: {
            /**
             * Add an extra content box
             */
            setExtraContent: () => ReturnType;
        };
    }
}

export const ExtraContent = Node.create<ExtraContentOptions>({
    name: 'extraContent',

    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },

    group: 'block',

    content: 'block+',

    draggable: true,

    isolating: false,

    selectable: true,

    atom: false,

    addAttributes() {
        return {};
    },

    parseHTML() {
        return [
            {
                tag: 'div[data-extra-content]',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            mergeAttributes(
                {
                    'data-extra-content': 'true',
                    class: 'extra-content-box',
                },
                this.options.HTMLAttributes,
                HTMLAttributes
            ),
            0,
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer(ExtraContentComponent);
    },

    addCommands() {
        return {
            setExtraContent:
                () =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                            content: [
                                {
                                    type: 'paragraph',
                                    content: [],
                                },
                            ],
                        });
                    },
        };
    },
});

export default ExtraContent; 